'use client'

import { QUERY_ROUTES, ROUTES } from '@/core/constants/routes'
import { useAuth } from '@/core/store/auth'
import { LogoutForm } from '@/features/auth/ui/components/logout-form'
import { Link, usePathname } from '@/i18n/navigation'
import { Avatar } from '@heroui/avatar'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@heroui/dropdown'
import { NavbarItem } from '@heroui/navbar'
import { useTranslations } from 'next-intl'

const NO_RESERVE_TRIP_ROUTES: string[] = [
  ROUTES.about,
  ROUTES.blog,
  ROUTES.contactUs,
  ROUTES.helpCenter,
  ROUTES.helpFaq,
  ROUTES.privacy,
  ROUTES.terms,
]

export const HeaderActions = () => {
  const t = useTranslations()
  const { user } = useAuth()
  const pathname = usePathname()
  const hasReserve = !NO_RESERVE_TRIP_ROUTES.some(route =>
    pathname.includes(route),
  )

  const getHref = () => {
    if (!hasReserve) {
      return ROUTES.home
    }

    const sendVerificationCode = QUERY_ROUTES.sendVerificationCode
    const searchParams = new URLSearchParams()
    searchParams.set(sendVerificationCode.name, sendVerificationCode.value)

    return `${pathname}?${searchParams.toString()}`
  }
  return (
    <>
      <NavbarItem>
        <Link
          href={ROUTES.helpCenter}
          className='flex items-center gap-1'
          passHref
          aria-label={t('ariaLabels.help')}
        >
          <span className='hidden sm:inline-block'>{t('links.help')}</span>
        </Link>
      </NavbarItem>
      <NavbarItem>
        {user ? (
          <Dropdown placement='bottom-end'>
            <DropdownTrigger>
              <Avatar
                as='button'
                className='h-12 w-12 cursor-pointer transition-transform'
                color='default'
                name={user.fullName}
                size='md'
                src={user.avatar.url}
              />
            </DropdownTrigger>
            <DropdownMenu
              aria-label='Profile Actions'
              variant='flat'
              itemClasses={{
                title: 'text-base',
              }}
            >
              <DropdownItem key='profile' as={Link} href={ROUTES.tripHistory}>
                {t('links.profile')}
              </DropdownItem>
              <DropdownItem key='chats' as={Link} href={ROUTES.chats}>
                {t('links.chats')}
              </DropdownItem>
              <DropdownItem key='trips' as={Link} href={ROUTES.trips}>
                {t('links.trips')}
              </DropdownItem>

              <DropdownItem key='logout' color='danger'>
                <LogoutForm />
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        ) : (
          <Link
            href={getHref()}
            scroll={false}
            passHref
            className='cursor-pointer'
          >
            <span className='bg-sky-blue inline-block w-full rounded px-4 py-2 text-white'>
              {hasReserve ? t('links.signin') : t('links.bookNow')}
            </span>
          </Link>
        )}
      </NavbarItem>
    </>
  )
}
